import React, { useEffect, useState } from 'react';
import { FaUser, FaServer, FaStar, FaDiscord } from 'react-icons/fa';

const StatsPage = () => {
  const [activeUsers, setActiveUsers] = useState(0);
  const [totalPlayTime, setTotalPlayTime] = useState(0);
  const [discordMembers, setDiscordMembers] = useState(0);

  useEffect(() => {
    const fetchActiveUsers = async () => {
      try {
        const response = await fetch('https://cablenetwork-api.jakefarrell.ie/api/active-users');
        const data = await response.json();
        setActiveUsers(data?.activeUsersCount ?? 0);
      } catch (error) {
        console.error('Error fetching active users count:', error);
      }
    };

    const fetchTotalPlayTime = async () => {
      try {
        const response = await fetch('https://cablenetwork-api.jakefarrell.ie/api/total-playtime');
        const data = await response.json();
        setTotalPlayTime(data?.totalPlayTime ?? 0);
      } catch (error) {
        console.error('Error fetching total playtime:', error);
      }
    };

    const fetchDiscordMembers = async () => {
      try {
        const response = await fetch('https://discord.com/api/guilds/702877615136178326/widget.json');
        const data = await response.json();
        setDiscordMembers(data?.presence_count || data?.members?.length || 0);
      } catch (error) {
        console.error('Error fetching Discord members count:', error);
      }
    };

    fetchActiveUsers();
    fetchTotalPlayTime();
    fetchDiscordMembers();
  }, []);

  const formatPlayTime = (seconds = 0) => {
    const days = (seconds || 0) / 86400;
    return `${days.toFixed(2)} days`;
  };

  const stats = [
    {
      id: 1,
      icon: <FaUser className="text-4xl text-green-500" />,
      number: (activeUsers ?? 0).toLocaleString(),
      description: 'Unique Players',
    },
    {
      id: 2,
      icon: <FaServer className="text-4xl text-green-500" />,
      number: '6',
      description: 'Years Online',
    },
    {
      id: 3,
      icon: <FaStar className="text-4xl text-green-500" />,
      number: formatPlayTime(totalPlayTime),
      description: 'Total Playtime',
    },
    {
      id: 4,
      icon: <FaDiscord className="text-4xl text-green-500" />,
      number: (discordMembers ?? 0).toLocaleString(),
      description: 'Discord Members Online',
    },
  ];

  return (
    <div className="bg-white dark:bg-[#09090b] pt-10 transition-colors duration-200">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-[#fafafa] mb-8 text-center">Our Stats</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="bg-green-100 dark:bg-[#131316] dark:border dark:border-[#27272a] rounded-lg shadow-lg p-6 flex flex-col items-center hover:shadow-xl transition-shadow"
            >
              <div className="mb-4">{stat.icon}</div>
              <h2 className="text-4xl font-bold text-gray-800 dark:text-[#fafafa] mb-2">{stat.number}</h2>
              <p className="text-gray-600 dark:text-[#a1a1aa] text-center">{stat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsPage;
